import { render, staticRenderFns } from "./ExerciseChangeBoxes.vue?vue&type=template&id=2f5375e1&scoped=true"
import script from "./ExerciseChangeBoxes.vue?vue&type=script&lang=js"
export * from "./ExerciseChangeBoxes.vue?vue&type=script&lang=js"
import style0 from "./ExerciseChangeBoxes.vue?vue&type=style&index=0&id=2f5375e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5375e1",
  null
  
)

export default component.exports